import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class DropDownForm extends React.Component {

  static propTypes = {
    config: PropTypes.object,
    onDone: PropTypes.func,
    onUpdate: PropTypes.func
  }

  formRef = React.createRef()

  state = {
    config: null
  }

  _handleChange = this._handleChange.bind(this)
  _handleDone = this._handleDone.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)

  render() {
    if(!this.state.config) return null
    return <Form { ...this._getForm() } />
  }

  componentDidMount() {
    this.setState({
      config: {
        ...this._getDefault(),
        ...this.props.config
      }
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const { config } = this.state
    if(!_.isEqual(config, prevState.config)) {
      this.props.onUpdate(config)
    }
  }

  _getForm() {
    const { config } = this.state
    return {
      ref: this.formRef,
      title: 't(Dropdown)',
      onChange: this._handleChange,
      onSubmit: this._handleDone,
      cancelText: null,
      saveText: null,
      buttons: [
        { label: 't(Done)', color: 'blue', handler: this._handleSubmit }
      ],
      sections: [
        {
          fields: [
            { label: 't(Name)', name: 'name', type: 'tokenfield', required: true, value: config.name },
            { label: 't(Label)', name: 'label', type: 'textfield', value: config.label },
            { label: 't(Instructions)', name: 'instructions', type: 'htmlfield', value: config.instructions },
            { label: 't(Prompt)', name: 'prompt', type: 'textfield', value: config.prompt },
            { label: 't(Required)', name: 'required', type: 'checkbox', prompt: 't(This field is required)', value: config.required },
            { label: 't(Options)', name: 'options', type: 'tablefield', columns: [
              { label: 't(Value)', key: 'value' },
              { label: 't(Text)', key: 'text' }
            ], value: config.options }
          ]
        }
      ]
    }
  }

  _getDefault() {
    return {
      label: '',
      token: '',
      instructions: '',
      prompt: '',
      required: false,
      options: []
    }
  }

  _handleChange(config) {
    const { label } = config
    const name = _.get(config, 'name.value')
    this.setState({
      config: {
        ...this.state.config,
        ...config,
        ...config.name && ((!label && name.length === 1) || name.slice(0,-1) === label) ? {
          label: config.name.value
        } : {}
      }
    })
  }

  _handleDone() {
    this.props.onDone()
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

}

export default DropDownForm
